import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-create-v2',
  templateUrl: './create-v2.component.html',
  styleUrls: ['./create-v2.component.css']
})
export class CreateV2Component implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
